import React, { useState } from 'react';
import { Box, Grid, useTheme } from '@mui/material';
import LoadingOverlay from '../../components/LoadingOverlay';
import PageHeader from '../../components/PageHeader';

import AppearanceSection from './AppearanceSection';
import CompanyInfoSection from './CompanyInfoSection';

const Settings = () => {
    const theme = useTheme();
    const [themeDark, setThemeDark] = useState(false);

    const handleThemeChange = () => {
        setThemeDark((prev) => !prev);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <LoadingOverlay />

            <Box
                sx={{
                    flex: 1,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    backgroundColor: theme.palette.background.default,
                }}
            >
                <Box mb={4}>
                    <PageHeader title="Configurações do Sistema" />
                </Box>

                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <CompanyInfoSection />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <AppearanceSection
                            themeDark={themeDark}
                            onThemeChange={handleThemeChange}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Settings;
